<div id="app-note-types-container">
  <p-blockUI [blocked]="loading === true" />
  <div class="ui-g ui-fluid">
    <div class="button-header" style="text-align: right">
      <div style="text-align: right">
        <app-progress-spinner [enabled]="saving" />
      </div>
      <div id="business-units-wrapper">
        <app-business-unit-filter
          (selectedBusinessUnitsChanged)="handleBusinessUnitChange()"
          #buFilter
        />
      </div>
      <div class="button-wrapper group">
        @if (canCreate === true) {
          <button
            pButton
            class="width-eighty"
            label="{{ 'COMMON.LABEL.BUTTONS.NEW' | translate }}"
            icon="fa fa-fw fa-plus-circle"
            (click)="newNoteType()"
          ></button>
        }
        <button
          pButton
          label="{{ 'COMMON.LABEL.BUTTONS.CLEAR' | translate }}"
          icon="fa fa-fw fa-eraser"
          (click)="clearScreen()"
        ></button>
        <button
          pButton
          class="refresh-button width-twenty"
          icon="fa fa-fw fa-refresh"
          (click)="refresh()"
        ></button>
      </div>
    </div>
  </div>
  <app-progress-spinner [enabled]="!elements" />
  <div [style.display]="!elements ? 'none' : ''">
    <app-general-grid
      [values]="elements"
      [columns]="columns"
      [loading]="loading"
      [totalRecords]="totalRecords"
      [filterable]="true"
      [screenName]="screenName"
      [rows]="rows"
      [lazy]="true"
      (lazyLoad)="lazyLoad($event)"
      [includeExportCSV]="false"
      (changeViewEvent)="changeViewEvent($event)"
      scrollHeight="calc(100vh - 325px)"
      [usePaginator]="true"
      [rowsPerPageOptions]="[50, 100, 200]"
      #grid
    />
  </div>

  <p-dialog
    [header]="dialogHeader"
    [(visible)]="displayDialog"
    showEffect="fade"
    [modal]="true"
    (onHide)="dialogClosed()"
    [transitionOptions]="'0ms'"
    [style]="{ width: '750px' }"
  >
    <form [formGroup]="form">
      <div>
        <div class="no-padding form">
          <div class="form-item">
            <div class="form-label">{{ 'ADMIN.LABEL.NAME' | translate }}:</div>
            <div class="form-input">
              <input
                type="text"
                pInputText
                formControlName="name"
                (change)="nameChanged()"
              />
            </div>
          </div>

          <div class="form-item">
            <div class="form-label">
              {{ 'COMMON.LABEL.ENABLE' | translate }}:
            </div>
            <div class="form-input">
              <p-checkbox formControlName="enabled" [binary]="true" />
            </div>
          </div>

          <div style="width: 100%">
            <p-pickList
              [source]="sourcePicklist"
              [target]="targetPicklist"
              targetHeader="{{ 'COMMON.LABEL.ASSIGNED_AORS' | translate }}"
              [dragdrop]="false"
              sourceHeader="{{ 'COMMON.LABEL.AVAILABLE_AORS' | translate }}"
              [responsive]="true"
              [showSourceControls]="false"
              [showTargetControls]="false"
              [sourceStyle]="{
                height: '250px',
                'box-shadow': 'rgba(0, 0, 0, 0.1) 0px 4px 12px',
              }"
              [targetStyle]="{
                height: '250px',
                'box-shadow': 'rgba(0, 0, 0, 0.1) 0px 4px 12px',
              }"
              [disabled]="form.disabled"
            >
              <ng-template let-aor pTemplate="item">
                <div>
                  <div>
                    <h5>{{ aor.name }}</h5>
                  </div>
                </div>
              </ng-template>
            </p-pickList>
          </div>

          <div class="form-item">
            <div class="form-label">
              {{ 'ADMIN.LABEL.CATEGORY' | translate }}:
            </div>
            <div>
              <p-multiSelect
                [options]="categories"
                optionLabel="name"
                placeholder="Select Categories"
                formControlName="categories"
                appendTo="body"
                scrollHeight="calc(100vh-35vh)"
              />
            </div>
          </div>
        </div>

        <div class="form-buttons">
          @if (canCreate === true || canEdit === true) {
            <div class="button-wrapper">
              <button
                pButton
                label="{{ 'COMMON.LABEL.BUTTONS.SAVE' | translate }}"
                icon="fa fa-fw fa-save"
                (click)="saveNoteType()"
                [disabled]="!this.form.valid"
              ></button>
            </div>
          }
          @if (canDelete === true) {
            <div class="button-wrapper">
              <button
                pButton
                label="{{ 'COMMON.LABEL.BUTTONS.DELETE' | translate }}"
                icon="fa fa-fw fa-trash"
                (click)="deleteNoteType()"
              ></button>
            </div>
          }
        </div>
      </div>
    </form>
  </p-dialog>
</div>
